import React from "react";

function ManualEvaluador(props) {
  // Lista de enlaces de videos con sus descripciones
  const videos = [
    {
      link: "https://www.powtoon.com/embed/bV4KEl146g7/",
      description: "Guia de uso para la bandeja Evluador",
    },
    {
      link: "https://www.powtoon.com/embed/b4DOeUzVjs9/",
      description: "Manual de uso boton proceso (Solicitud y Autoevaluación)",
    },
    {
      link: "https://www.powtoon.com/embed/eFVxIopQAs5/",
      description: "Manual de uso boton Avance",
    },
    {
      link: "https://www.powtoon.com/embed/d2cfEUDCGXw/",
      description: "Manual de uso boton Programación Horaria",
    },
    {
      link: "https://www.powtoon.com/embed/g0o7jyOiIEm/",
      description: "Manual de uso botón de reporsitorio de información",
    },
    {
      link: "https://www.powtoon.com/embed/g0o7jyOiIEm/",
      description: "Manual de uso botón de Agenda",
    },
  ];

  return (
    <div className="test">
      <div>
        <div className="container">
          <div className="text-center">
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Manuales de Uso
                  </h6>
                </div>
                <div className="card-body">
                  <div className="row">
                    {videos.map((video, index) => (
                      <div className="col-md-4 mb-4" key={index}>
                        <div className="embed-responsive embed-responsive-16by9">
                          <iframe
                            className="embed-responsive-item"
                            src={video.link}
                            allowFullScreen
                            title={`video-${index}`}
                          ></iframe>
                        </div>
                        <p className="mt-2 text-center">{video.description}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManualEvaluador;
